"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'epg';
exports.FETCH_SLOTS_BY_TIME_RANGE = exports.namespace + "/FETCH_SLOTS_BY_TIME_RANGE";
exports.FETCH_SLOT_BY_START_TIME = exports.namespace + "/FETCH_SLOT_BY_START_TIME";
exports.CLEAR_SELECTED_SLOT = exports.namespace + "/CLEAR_SELECTED_SLOT";
exports.FETCH_SLOTS_BY_IDS = exports.namespace + "/FETCH_SLOTS_BY_IDS";
exports.CLEAR_SCHEDULED_SLOTS = exports.namespace + "/CLEAR_SCHEDULED_SLOTS";
//# sourceMappingURL=constants.js.map